import React, { useEffect } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';

import Navbar from './components/Navbar';
import Banner from './components/Banner';
import HomeContent from './components/HomeContent';
import Footer from './components/Footer';
import Events from './components/Events';
import About from './components/About';
import Contact from './components/Contact';
import Classes from './components/Classes';
import './index.css';

function App() {
  const location = useLocation();

  // ===============================
  // Reveal on scroll animation
  // ===============================
  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const deviceMemory = navigator.deviceMemory || 4;
    const connection = navigator.connection || {};
    const slowNetwork = ['2g', 'slow-2g'].includes(connection.effectiveType);

    if (prefersReduced || deviceMemory <= 1 || slowNetwork) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('reveal');
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll('.revealable').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [location.pathname]); // re-run on route change

  // ===============================
  // Parallax scroll (safe)
  // ===============================
  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const deviceMemory = navigator.deviceMemory || 4;
    if (prefersReduced || deviceMemory <= 1) return;

    const elems = Array.from(document.querySelectorAll('[data-parallax]'));
    if (!elems.length) return;

    let rafId = null;

    const update = () => {
      const mid = window.innerHeight / 2;
      elems.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const factor = parseFloat(el.dataset.parallax) || 0.08;
        let y = (rect.top + rect.height / 2 - mid) * factor;
        y = Math.max(Math.min(y, 30), -30);
        el.style.transform = `translateY(${y}px)`;
      });
      rafId = null;
    };

    const onScroll = () => {
      if (rafId == null) rafId = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [location.pathname]); // re-init on route change

  // ===============================
  // App layout + routes
  // ===============================
  return (
    <div className="App">
      <Navbar />

      <main className="site">
        <Routes location={location} key={location.pathname}>

          {/* HOME */}
          <Route
            path="/"
            element={
              <>
                <Banner />
                <HomeContent />
              </>
            }
          />

          {/* EVENTS */}
          <Route path="/events" element={<Events />} />

          {/* ABOUT */}
          <Route path="/about" element={<About />} />

          {/* INVALID ROUTES → HOME */}
          <Route path="*" element={<Navigate to="/" replace />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/classes" element={<Classes />} />
          
        </Routes>

        <Footer />
      </main>
    </div>
  );
}

export default App;
